/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Practice_Feedback_StandoutInputs */



/**
* | output |
* | --- |
* | "Strong moment" |
*
* @param {Practice_Feedback_StandoutInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const practice_feedback_standout = /** @type {((inputs?: Practice_Feedback_StandoutInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_Feedback_StandoutInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Sterk moment")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Moment fort")
	return /** @type {LocalizedString} */ ("Strong moment")
});